module.exports = __webpack_public_path__ + "img/02-ลงทะเบียนลูกค้าปัจจุบัน.dac4264b.png";